<div class="context-panel-title-container" style="display: flex; justify-content: left; align-items: center; gap: 5px;">
  <div class="context-panel-icon">
    <div class="fa-duotone fa-history reviewed-documents-title-header"></div>
  </div>
  <div>Reviewed Documents</div>
</div>
